import { useEffect } from "react";
import styles from "./SectionCompletedCard.module.scss";

const playCompletionChime = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [
      [523.25, 0],
      [659.25, 0.18],
      [783.99, 0.36],
    ].forEach(([freq, delay]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.35, ctx.currentTime + delay);
      gain.gain.exponentialRampToValueAtTime(
        0.001,
        ctx.currentTime + delay + 0.4,
      );
      osc.start(ctx.currentTime + delay);
      osc.stop(ctx.currentTime + delay + 0.4);
    });
  } catch (_) {}
};

const SectionCompletedCard = ({ event, onClose }) => {
  useEffect(() => {
    if (event) playCompletionChime();
  }, [event]);

  if (!event) return null;

  const { order_id, section_items, completed_by_name } = event.payload ?? {};

  return (
    <div className={styles.sectionCompletedCard}>
      <div className="d-flex justify-content-between">
        <p>Order ID :</p>
        <p className="dark--text small-text-size">{order_id}</p>
      </div>

      {completed_by_name && (
        <div className="d-flex justify-content-between">
          <p>Completed by :</p>
          <p className="dark--text small-text-size">{completed_by_name}</p>
        </div>
      )}

      {section_items?.length > 0 && (
        <div>
          <p>Section Items :</p>
          {section_items.map((item) => (
            <div key={item?.id} className={styles.sectionCompletedCard__item}>
              <p className="dark--text mb-0">{item?.section?.name}</p>
              <span className="smallest-text-size success--rounded">
                {item?.status}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionCompletedCard;
